(function () {
  "use strict";

  function parseTarget(raw) {
    var n = parseFloat(raw);
    return Number.isFinite(n) ? n : null;
  }

  function animateValue(el, target, suffix) {
    var numEl = el.querySelector(".b2b-stat__number");
    if (!numEl) return;
    var suffixEl = el.querySelector(".b2b-stat__suffix");
    if (suffixEl && typeof suffix === "string") {
      suffixEl.textContent = suffix;
    }
    var duration = 1100;
    var start = performance.now();
    function frame(now) {
      var t = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      var current = Math.round(target * eased);
      numEl.textContent = String(current);
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        numEl.textContent = String(Math.round(target));
      }
    }
    requestAnimationFrame(frame);
  }

  function initStats() {
    var section = document.querySelector(".b2b-stats");
    if (!section || !("IntersectionObserver" in window)) return;

    var rows = section.querySelectorAll("[data-b2b-stat-target]");
    if (!rows.length) return;

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var wrap = entry.target;
          var raw = wrap.getAttribute("data-b2b-stat-target");
          var suffix = wrap.getAttribute("data-b2b-stat-suffix") || "";
          var target = parseTarget(raw);
          if (target === null) {
            obs.unobserve(wrap);
            return;
          }
          animateValue(wrap, target, suffix);
          obs.unobserve(wrap);
        });
      },
      { root: null, threshold: 0.35 }
    );

    rows.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStats);
  } else {
    initStats();
  }
})();
